export default [
    {title: "General.Country.Egypt", value: "Egypt"}
]
